<template>
  <div class="center-panel">
    <dv-border-box-12 class="panel-box trend-section">
      <div class="panel-inner">
        <div class="section-title">
          <dv-decoration-6 style="width:200px;height:20px;" />
          <span class="title-text">销售额趋势（全平台）</span>
        </div>
        <SaleTrend />
      </div>
    </dv-border-box-12>
    <dv-border-box-12 class="panel-box geo-section">
      <div class="panel-inner">
        <div class="section-title">
          <dv-decoration-6 style="width:200px;height:20px;" />
          <span class="title-text">地域销售热力图</span>
        </div>
        <GeoHeatMap />
      </div>
    </dv-border-box-12>
    <dv-border-box-12 class="panel-box quadrant-section">
      <div class="panel-inner">
        <div class="section-title">
          <dv-decoration-6 style="width:200px;height:20px;" />
          <span class="title-text">SKU销售四象限分析</span>
        </div>
        <SkuQuadrant />
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
import SaleTrend from './SaleTrend.vue'
import GeoHeatMap from './GeoHeatMap.vue'
import SkuQuadrant from './SkuQuadrant.vue'

export default {
  name: 'CenterPanel',
  components: { SaleTrend, GeoHeatMap, SkuQuadrant }
}
</script>

<style scoped>
.center-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.trend-section {
  min-height: 260px;
}

.geo-section {
  min-height: 320px;
}

.quadrant-section {
  min-height: 240px;
}

.panel-inner {
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.title-text {
  font-size: 15px;
  font-weight: bold;
  color: #00D4FF;
  white-space: nowrap;
}
</style>
